import setLocale from '$lib/locales/setLocale';
import type { LayoutLoad } from './$types';
import { direction } from '$lib/stores/directionStore';
import { localeToDirection } from '$lib/locales';
import { getAllCollection } from './helpers/getAllCollection';

export const load = (async ({ data }) => {
	const {
		respSessionHubUser,
		respHub,
		respCollaborators,
		respCollections,
		respWidgets,
		respFeaturedPosts,
		respPinnedPosts,
	} = data;

	direction.set(localeToDirection(respHub?.hub?.locale || 'en'));
	await setLocale(data.respHub?.hub?.locale || 'en');

	let collectionsData;
	if (respCollections) {
		collectionsData = respHub?.hub?.settings?.hide_all_collection
			? respCollections
			: [getAllCollection(respHub?.hub?.id), ...respCollections];
	}

	return {
		respSessionHubUser,
		respCollaborators,
		respFeaturedPosts,
		respPinnedPosts,
		collectionsData,
		respWidgets,
		respHub,
		postsFilters: { collectionSlug: '', tag: '' },
	};
}) satisfies LayoutLoad;
